import React, { useEffect, useState } from "react";
import "./Product_details.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Our_choices from "./our_choices/Our_choices";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import Product_vdo_preview from "../home/product_vdo_preview/Product_vdo_preview";
import Product_details_swiper from "./product_details_swiper/Product_details_swiper";
import Product_info from "./product_info/Product_info";
import Product_overview from "./product_overview/Product_overview";
import Product_Rating from "./product_Rating/Product_Rating";
import { getProduct } from "../../features/products/productsSlice";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Demo_ProductCategory from "../home/demo_product/Demo_ProductCategory";
import { getAllCategories } from "../../features/master/masterSlice";
import Spinner from "react-bootstrap/Spinner";
function Product_details() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "PRODUCT", link: "", isActive: true },
  ];

  const { id } = useParams();

  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const product = useSelector((state) => state.product.product);

  // VARIANT STATES
  const [selectedVariant, setSelectedVariant] = useState({});
  const [activeMetal, setActiveMetal] = useState(null);
  const [activeSize, setActiveSize] = useState(null);
  const [activeTriple, setActiveTriple] = useState(null);

  const categories = useSelector((state) => state.master.categories);

  useEffect(() => {
    dispatch(getAllCategories({}));
  }, [dispatch]);

  useEffect(() => {
    const fetchProduct = async () => {
      if (!id) return;

      setLoader(true);

      try {
        await dispatch(getProduct(id)).unwrap();
      } catch (error) {
        console.error(error);
      } finally {
        setLoader(false);
      }
    };

    fetchProduct();
  }, [dispatch, id]);

  // AUTO SELECT FIRST VARIANT
  useEffect(() => {
    setSelectedVariant({});
    if (product?.Product_Variants?.length > 0) {
      const firstMetal = product?.Product_Variants?.[0];

      setActiveMetal(firstMetal);
      setSelectedVariant(firstMetal);

      if (firstMetal?.Double_Variants?.length > 0) {
        const firstSize = firstMetal?.Double_Variants?.[0];

        setActiveSize(firstSize);
        setSelectedVariant(firstSize);

        if (firstSize?.Triple_Variants?.length > 0) {
          const firstTriple = firstSize?.Triple_Variants?.[0];

          setActiveTriple(firstTriple);
          setSelectedVariant(firstTriple);
        } else {
          setActiveTriple(null);
        }
      } else {
        setActiveSize(null);
      }
    }
  }, [product, id]);

  const breakpoints = {
    320: { slidesPerView: 3 },
    485: { slidesPerView: 5 },
    768: { slidesPerView: 4 },
    992: { slidesPerView: 4 },
    1024: { slidesPerView: 5 },
  };

  

  return (
    <>
      {" "}
      {loader ? (
        <>
          <div className="position-fixed top-0 start-0 w-100 vh-100 d-flex justify-content-center align-items-center bg-white">
            <Spinner animation="border" variant="warning" />
          </div>
        </>
      ) : (
        <>
          <section className="Product_details">
            <div className="container-fluid">
              <Breadcrumb_comp breadcrumbs={breadcrumbs} />

              <div className="row">
                <div className="col-xl-5 col-lg-6">
                  <Product_details_swiper
                   selectedVariant={selectedVariant}
                    product={product}
                    activeMetal={activeMetal}
                    activeSize={activeSize}
                    activeTriple={activeTriple}
                  />
                </div>

                <div className="col-xl-7 col-lg-6">
                  <div className="Product_details_info_holder">
                    <Product_info
                      product={product}
                      itemID={id}
                      selectedVariant={selectedVariant}
                      setSelectedVariant={setSelectedVariant}
                      activeMetal={activeMetal}
                      setActiveMetal={setActiveMetal}
                      activeSize={activeSize}
                      setActiveSize={setActiveSize}
                      activeTriple={activeTriple}
                      setActiveTriple={setActiveTriple}
                    />

                    <div className="overview_tab">
                      <Product_overview
                        product={product}
                        selectedVariant={selectedVariant}
                        activeMetal={activeMetal}
                        activeSize={activeSize}
                        activeTriple={activeTriple}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Product_vdo_preview product={product} />
              <Product_Rating product={product} />
              <div className="demo_product_list_holder">
                <Demo_ProductCategory
                  breakpoints={breakpoints}
                  products={categories}
                />
              </div>

              <Our_choices
                product={product}
                selectedVariant={selectedVariant}
                activeMetal={activeMetal}
                activeSize={activeSize}
                activeTriple={activeTriple}
              />

              {/* <Stay_Connected product={product} /> */}
            </div>
          </section>
        </>
      )}
    </>
  );
}

export default Product_details;
